module.exports = __webpack_public_path__ + "img/Erekle Inashvili.6a231f7b.png";